"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _preactCompat = require("preact-compat");

var _Content = _interopRequireDefault(require("./Content"));

var _Meta = _interopRequireDefault(require("./Meta"));

var _Title = _interopRequireDefault(require("./Title"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var SearchResult = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2.default)(SearchResult, _PureComponent);

  var _super = _createSuper(SearchResult);

  function SearchResult() {
    (0, _classCallCheck2.default)(this, SearchResult);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(SearchResult, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          title = _this$props.title,
          url = _this$props.url,
          icon = _this$props.icon,
          target = _this$props.target,
          content = _this$props.content,
          anchorRel = _this$props.anchorRel,
          postTitleIconClass = _this$props.postTitleIconClass,
          metaItems = _this$props.metaItems,
          featuredImage = _this$props.featuredImage,
          featuredImageAltText = _this$props.featuredImageAltText,
          clickCallback = _this$props.clickCallback;
      return (0, _preact.h)("article", null, (0, _preact.h)("a", {
        className: "search-result",
        href: (0, _absoluteUrlRuntime.resolveUrl)(url),
        rel: anchorRel,
        target: target,
        onClick: function onClick() {
          clickCallback();
        },
        "data-track-type": "click",
        "data-element-name": "Search Result",
        "aria-label": title
      }, (0, _preact.h)("div", {
        className: "search-result-icon"
      }, icon), (0, _preact.h)("div", {
        className: "search-result-data"
      }, (0, _preact.h)(_Title.default, {
        title: title,
        postTitleIconClass: postTitleIconClass
      }), (0, _preact.h)(_Meta.default, {
        items: metaItems
      }), (0, _preact.h)(_Content.default, {
        content: content,
        featuredImage: featuredImage,
        featuredImageAltText: featuredImageAltText,
        topicTitle: title
      }))));
    }
  }]);
  return SearchResult;
}(_preactCompat.PureComponent);

exports.default = SearchResult;